import { fmtDateTime } from "@/lib/date";

// Build Add-to-Calendar links for an event. Assumes 2h duration when no end time.
function toCalDate(iso) {
  const d = new Date(iso);
  if (isNaN(d)) return "";
  return d.toISOString().replace(/[-:]/g, "").split(".")[0] + "Z";
}

export function googleCalendarUrl(ev) {
  const start = new Date(ev.starts_at);
  const end = new Date(start.getTime() + 2 * 60 * 60 * 1000);
  const loc = [ev.venue, ev.city, ev.country].filter(Boolean).join(", ");
  const params = new URLSearchParams({
    action: "TEMPLATE",
    text: ev.title || "Gospel Event",
    dates: `${toCalDate(start)}/${toCalDate(end)}`,
    details: `${ev.description || ""}${ev.link ? `\n\n${ev.link}` : ""}\n\nvia In His Image Radio`,
    location: loc,
  });
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
}

export function downloadIcs(ev) {
  const start = new Date(ev.starts_at);
  const end = new Date(start.getTime() + 2 * 60 * 60 * 1000);
  const loc = [ev.venue, ev.city, ev.country].filter(Boolean).join(", ");
  const esc = (s) => (s || "").replace(/\n/g, "\\n").replace(/,/g, "\\,").replace(/;/g, "\\;");
  const ics = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//In His Image Radio//Events//EN",
    "BEGIN:VEVENT",
    `UID:${ev.id}@inhisimageradio`,
    `DTSTAMP:${toCalDate(new Date())}`,
    `DTSTART:${toCalDate(start)}`,
    `DTEND:${toCalDate(end)}`,
    `SUMMARY:${esc(ev.title)}`,
    `DESCRIPTION:${esc(ev.description)}${ev.link ? `\\n\\n${esc(ev.link)}` : ""}`,
    `LOCATION:${esc(loc)}`,
    "END:VEVENT",
    "END:VCALENDAR",
  ].join("\r\n");
  const blob = new Blob([ics], { type: "text/calendar;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${(ev.title || "event").replace(/[^a-z0-9]+/gi, "-").toLowerCase()}.ics`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}


export async function shareEvent(ev) {
  const url = `${window.location.origin}/events`;
  const when = fmtDateTime(ev.starts_at);
  const loc = [ev.venue, ev.city, ev.country].filter(Boolean).join(", ");
  const text = `Join me at ${ev.title} 🙌\n${when}${loc ? ` · ${loc}` : ""}\nvia In His Image Radio`;
  if (navigator.share) {
    try { await navigator.share({ title: ev.title, text, url }); return "shared"; }
    catch (e) { if (e.name === "AbortError") return "cancel"; }
  }
  try { await navigator.clipboard.writeText(`${text}\n${url}`); return "copied"; }
  catch (e) { return "error"; }
}
